import * as React from "react"

import { cn } from "@/lib/utils"

interface TextareaProps extends React.ComponentProps<"textarea"> {
  /**
   * Dense tier (Document Designer inspector, G4): `min-h-14`, 8px / 4px
   * padding, 12px text at every breakpoint. Default is unchanged.
   */
  density?: "default" | "dense"
}

function Textarea({ className, density = "default", ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      data-density={density}
      className={cn(
        // IC-555: bg-background, not bg-transparent — see ui/input.tsx's comment.
        "flex field-sizing-content min-h-16 w-full rounded-md border border-input bg-background px-2.5 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        density === "dense" && "min-h-14 px-2 py-1 text-xs md:text-xs",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
